
import { Role } from "./role";

export class UserBasicInfo {
    
    id: number | undefined;
    nickname: string | undefined;
    email: string | undefined;
    token: string | undefined;
    statusId: number | undefined;
    roles: EnumUserRole[] | undefined;
    instagramNickname: string | undefined;

    password: string | undefined;
    confirmPassword: string | undefined;

    //fromUser(user: User): void {
    //    this.id = user.id;
    //    this.nickname = user.nickname;
    //    this.password = user.password;
    //    this.confirmPassword = user.confirmPassword;
    //   this.email = user.email;
    //    this.statusId = user.statusId;
    //    this.roles = user.roles;
    //    this.instagramNickname = user.instagramNickname;        
    //}

    public getAuthorities(): Array<Role> {
        
        let rolesList:Set<Role> = new Set<Role>();

        if (this.roles != null && this.roles.length > 0) {
            rolesList = new Set<Role>();
            this.roles.forEach(userRole => {
                rolesList.add(new Role(userRole));
            });
        }
        return Array.from(rolesList);
    }

    public toString(): string {
        return "USER INFO - id: " + this.id + ", nickname: " + this.nickname +  ", email: " + this.email + 
        ", status id: " + this.statusId +  ", Instagram nickname: " + this.instagramNickname +  ", profiles: " + this.roles + 
        ", token: " + this.token;
    }

    public static statusById(id: number): EnumEntityStatus {
            
        switch (id) {
            case 1: return EnumEntityStatus.approval;
            case 2: return EnumEntityStatus.active;
            case 3: return EnumEntityStatus.refused;
            case 4: return EnumEntityStatus.inactive;
            case 5: return EnumEntityStatus.suspended;
            case 6: return EnumEntityStatus.banned;
            case 7: return EnumEntityStatus.erased;
            default: return EnumEntityStatus.unknown;
        }
    }

    public static statusIdByEnum(status: EnumEntityStatus): number {
        switch(status) {
            case EnumEntityStatus.approval: return 1;
            case EnumEntityStatus.active: return 2;
            case EnumEntityStatus.refused: return 3;
            case EnumEntityStatus.inactive: return 4;
            case EnumEntityStatus.suspended: return 5;
            case EnumEntityStatus.banned: return 6;
            case EnumEntityStatus.erased: return 7;
            default: return -1;
        }
    }    
}

export enum EnumUserRole {
    NONE = "NONE",
    CUSTOMER = "CUSTOMER",
    SOMMELIER = "SOMMELIER",
    DATA_ANALYST = "DATA_ANALYST",
    CUSTOMER_CARE = "CUSTOMER_CARE",
    EDITOR = "EDITOR",
    USER_MANAGER = "USER_MANAGER",
    ADMINISTRATOR = "ADMINISTRATOR",
    ANY = "ANY"
}

export enum EnumEntityStatus {
    approval = "approval",
    active = "active",
    refused = "refused",
    inactive = "inactive",
    suspended = "suspended",
    banned = "banned",
    erased = "erased",
    unknown = "unknown"
}

export enum EnumUserLegalEntityRole {
    NONE = "NONE",
    ADMINISTRATOR = " ADMINISTRATOR",
    STORE_MANAGER = "STORE_MANAGER",
    USER_MANAGER = "USER_MANAGER",
    ANY = "ANY"
}

export enum EnumUserLegalEntityProfile {
    NONE,
    ADMINISTRATOR,
    ASSOCIATE,
    CHIEF_EXECUTIVE,
    CONSULTANT,
    COUNCILOR,
    EMPLOYEE,
    EXECUTIVE,
    MANAGER,
    MANAGING_DIRECTOR,
    OPERATOR,
    OWNER,
    PRESIDENT,
    PROCURER,
    SHAREHOLDER,
    VICE_PRESIDENT,
    DELEGATED,
    ANY
}